// import { TypeScriptConfigurationOverwrite } from 'fork-ts-checker-webpack-plugin/lib/typescript-reporter/TypeScriptConfigurationOverwrite';
import { routesTypes as types, routes } from '.';

export const makeRoutes = (): types.Route[] =>
  routes;
